import { Calendar, Clock, Video } from "lucide-react";
import Reveal from "./Reveal";
import CtaButton from "./CtaButton";

const DAYS = [
    { day: "MONDAY", ms: "ISNIN", blob: "bg-electric/15" },
    { day: "TUESDAY", ms: "SELASA", blob: "bg-neon/15" },
];

const Schedule = () => (
    <section data-testid="schedule-section" className="relative py-24 md:py-32">
        <div className="pointer-events-none absolute right-0 top-1/4 h-[400px] w-[400px] rounded-full bg-neon/10 blur-3xl" />
        <div className="relative mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
            <Reveal>
                <p className="font-mono text-[11px] uppercase tracking-[0.25em] text-neon">
                    Jadual mingguan
                </p>
                <h2 className="mt-5 max-w-3xl font-display text-3xl font-extrabold tracking-tight text-white sm:text-4xl md:text-6xl">
                    SESI SETIAP <span className="text-duo-grad">MINGGU</span>
                </h2>
            </Reveal>

            <div className="mt-12 grid gap-5 md:grid-cols-2">
                {DAYS.map((d, i) => (
                    <Reveal key={d.day} delay={0.1 * i}>
                        <div
                            data-testid={`schedule-day-${i + 1}`}
                            className="card-luxe group relative overflow-hidden rounded-3xl p-8 transition duration-300 hover:-translate-y-1 hover:border-neon/40 md:p-10"
                        >
                            <div
                                className={`pointer-events-none absolute -right-12 -top-12 h-40 w-40 rounded-full ${d.blob} blur-2xl`}
                            />
                            <p className="relative font-mono text-[10px] uppercase tracking-[0.22em] text-white/40">
                                {d.ms}
                            </p>
                            <h3 className="relative mt-4 font-display text-3xl font-extrabold tracking-tight text-white md:text-4xl">
                                {d.day}
                            </h3>
                            <div className="relative mt-6 space-y-3">
                                <p className="flex items-center gap-3 text-sm text-white/70">
                                    <Clock size={15} className="text-neon" />
                                    8:30 PM – 10:00 PM
                                    <span className="text-white/40">
                                        (Waktu Malaysia)
                                    </span>
                                </p>
                                <p className="flex items-center gap-3 text-sm text-white/70">
                                    <Video size={15} className="text-neon" />
                                    Live via Zoom
                                </p>
                                <p className="flex items-center gap-3 text-sm text-white/70">
                                    <Calendar size={15} className="text-neon" />
                                    Berulang setiap minggu
                                </p>
                            </div>
                        </div>
                    </Reveal>
                ))}
            </div>

            <Reveal delay={0.1}>
                <div className="mt-10 flex flex-col gap-3 sm:flex-row sm:flex-wrap sm:items-center">
                    <CtaButton location="After Schedule" testId="schedule-cta-button">
                        PM Admin to Join
                    </CtaButton>
                </div>
            </Reveal>
        </div>
    </section>
);

export default Schedule;
